import { render, staticRenderFns } from "./DynamicChart.global.vue?vue&type=template&id=93690582&lang=pug&"
import script from "./DynamicChart.global.vue?vue&type=script&lang=ts&"
export * from "./DynamicChart.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports